(function(){
  'use strict';
  if(window.__SHCartResilienceV111)return;
  window.__SHCartResilienceV111=true;

  function messageFrom(payload,status){
    if(payload){
      if(typeof payload.description==='string'&&payload.description)return payload.description;
      if(typeof payload.message==='string'&&payload.message)return payload.message;
    }
    if(status===429)return 'The shop is busy right now. Please wait a moment and try again.';
    return 'We couldn\'t add this item to your bag. Please check your connection and try again.';
  }

  function install(attempt){
    if(!window.theme||!theme.AjaxProduct||!theme.AjaxProduct.prototype){
      if(attempt<40)window.setTimeout(function(){install(attempt+1);},50);
      return;
    }

    var prototype=theme.AjaxProduct.prototype;
    if(prototype.__shCartResilienceV111)return;
    prototype.__shCartResilienceV111=true;

    prototype.addItemFromForm=function(event){
      event.preventDefault();
      if(this._shSubmitting||!this.form||!this.addToCart)return;

      var instance=this;
      var button=this.addToCart;
      var controller=typeof AbortController==='function'?new AbortController():null;
      var timeout=controller?window.setTimeout(function(){controller.abort();},20000):null;
      var request={
        method:'POST',
        body:theme.utils.serialize(this.form),
        credentials:'same-origin',
        headers:{
          'Content-Type':'application/x-www-form-urlencoded',
          'X-Requested-With':'XMLHttpRequest',
          'Accept':'application/json'
        }
      };
      if(controller)request.signal=controller.signal;

      this._shSubmitting=true;
      button.classList.add('btn--loading');
      button.setAttribute('aria-busy','true');

      fetch(theme.routes.cartAdd,request)
        .then(function(response){
          return response.text().then(function(text){
            var payload=null;
            try{payload=text?JSON.parse(text):null;}catch(error){}
            if(!response.ok){
              var failure=new Error(messageFrom(payload,response.status));
              failure.payload=payload;
              failure.status=response.status;
              throw failure;
            }
            if(!payload)throw new Error(messageFrom(null,response.status));
            return payload;
          });
        })
        .then(function(payload){
          if(payload.status&&Number(payload.status)>=400){
            instance.error({description:messageFrom(payload,Number(payload.status))});
            return;
          }
          instance.success(payload);
          if(document.body.classList.contains('template-cart')){
            window.scrollTo(0,0);
            window.location.reload();
          }
        })
        .catch(function(error){
          instance.error({description:error&&error.name==='AbortError'?'Adding this item took too long. Please try again.':messageFrom(error&&error.payload,error&&error.status)});
        })
        .finally(function(){
          if(timeout)window.clearTimeout(timeout);
          instance._shSubmitting=false;
          button.classList.remove('btn--loading');
          button.removeAttribute('aria-busy');
        });
    };
  }

  install(0);
})();